import React from 'react';
import { Box, costFormater, Field, FieldTypes, Text } from '@common-fe/common-fe';
import _ from 'lodash';

import { VALIDATORS } from '@/common';

import {
  AccountFundingConfigPaylod,
  AUTO_FUNDING_LABEL,
  CategorySpendLimitPayload,
  toAutoFundingKey,
  toCategorySpendLimitKey,
  toSpendLimitKey,
} from '../CoverageLevels.constants';

export const getAccountFundingValidator = (item: AccountFundingConfigPaylod) =>
  VALIDATORS.REQUIRED_STRING.test({
    test(val) {
      const numberVal = _.toNumber(val);
      if (_.isNaN(numberVal)) return false;
      const min = item?.minElectionAmount ?? 0;
      const max = item?.maxElectionAmount ?? Number.MAX_SAFE_INTEGER;
      if (numberVal < min || numberVal > max) {
        return this.createError({
          message: `Should be in range from ${costFormater(min, true)} to ${costFormater(max, true)}`,
        });
      }
      return true;
    },
  });

export const getAccountFundingItems = (item: AccountFundingConfigPaylod) =>
  ({
    name: toAutoFundingKey(item.planId || ''),
    showRequireIcon: true,
    type: FieldTypes.Currency,
    label: (
      <Box>
        <Text margin={{ bottom: 'xsmall' }} weight="bold">
          {AUTO_FUNDING_LABEL}
        </Text>
        <Box>
          <Text size="small" weight="normal" style={{ maxWidth: '220px' }} color="textSecondary">
            According to the chosen plan, the amount must be between{' '}
            {costFormater(item?.minElectionAmount, true)} and {costFormater(item?.maxElectionAmount, true)}.
          </Text>
        </Box>
      </Box>
    ),
    placeholder: 'Enter $ amount',
    value: item.autoEnrollmentAmount,
    validator: getAccountFundingValidator(item),
    fieldGroupTitle: item?.planName,
    isFieldGrouped: true,
  }) as Field;

export const getAccountFundingItemsValidation = (item: AccountFundingConfigPaylod) =>
  ({
    name: toAutoFundingKey(item.planId || ''),
    type: FieldTypes.Currency,
    placeholder: 'Enter $ amount',
    value: item.autoEnrollmentAmount,
    validator: getAccountFundingValidator(item),
  }) as Field;

export const getPerPersonSpendLimitField = (item: AccountFundingConfigPaylod) => {
  return {
    name: toSpendLimitKey(item.planId || ''),
    type: FieldTypes.Currency,
    label: 'Per person spend limit',
    placeholder: 'Enter $ amount',
    value: item.perPersonSpendLimit,
    validator: VALIDATORS.POSITIVE_NUMBER_ONLY,
    isFieldGrouped: true,
  } as Field;
};

export const getPerPersonSpendLimitValidation = (item: AccountFundingConfigPaylod) =>
  ({
    name: toSpendLimitKey(item.planId || ''),
    type: FieldTypes.Currency,
    placeholder: 'Enter $ amount',
    value: item.perPersonSpendLimit,
    validator: VALIDATORS.POSITIVE_NUMBER_ONLY,
  }) as Field;

export const getCategorySpendLimitField = (item: CategorySpendLimitPayload, label: string) =>
  ({
    name: toCategorySpendLimitKey(item.planId || '', item.categoryType),
    type: FieldTypes.Currency,
    label,
    placeholder: 'Enter $ amount',
    value: item.categorySpendLimit,
    validator: VALIDATORS.POSITIVE_NUMBER_ONLY,
    isFieldGrouped: true,
  }) as Field;

export const getCategorySpendLimitValidation = (item: CategorySpendLimitPayload) =>
  ({
    name: toCategorySpendLimitKey(item.planId || '', item.categoryType),
    type: FieldTypes.Currency,
    placeholder: 'Enter $ amount',
    value: item.categorySpendLimit,
    validator: VALIDATORS.POSITIVE_NUMBER_ONLY,
  }) as Field;
